import React from "react";
import AddContentPage from "../catalogue/AddContentPage";
import { createShowGeneralContent } from "../../../store/actions/uploadMediaAction";

const AddShow = () => (
  <AddContentPage
    title="Add Show"
    genreType="tv shows"
    extraPayload={{ category: "tv_show" }}
    createAction={createShowGeneralContent}
    savedKey="savedTvShow"
    editPath={(id) => `/dashboard/update-show/${id}`}
    missingKey="Please Fill Show Info!"
    successKey="Show Info Submitted Successfully!"
    cancelPath="/dashboard/show-list"
  />
);

export default React.memo(AddShow);
